
import { Component, mixins } from '@niknevis/vue-modules'
import { InjectReactive } from 'vue-property-decorator'
import { ContentCampaignResourceType } from '@/modules/content-campaign/models/content-campaign-resource.model'
import PanelContentItemTableRow from '@/modules/content-item/components/panel/table/PanelContentItemTableRow.vue'

@Component
export default class PanelContentCampaignItemsTableRow extends mixins<PanelContentItemTableRow>(PanelContentItemTableRow) {
  @InjectReactive()
  campaign!: ContentCampaignResourceType

  get withData() {
    return {
      statuses: this.campaign.item_statuses,
      content_types: this.campaign.content_types
    }
  }
}
